import React, { useState, useEffect } from "react";
import { NavLink as Link } from "react-router-dom";
import Logo from "../../images/Avanse-Education-Loans-Logo.png";
import PartnerLogo from "../../images/Partner-Managment.png";
import LeadLogo from "../../images/Lead-Management.png";
import ApplicationLogo from "../../images/Application.png";
import deleteIcon from "../../images/delet-branch.png";
import Documents from "../../images/Documents.png";
import Human from "../../images/human1.png";
import BranchDetails from "../../images/BranchDetails.png";
import BackArrow from "../../images/back-arrow.png";
import { Button, Form, message, Modal, notification } from "antd";
import { Col, Row, Nav } from "react-bootstrap";

import {
  getTeamSideBarDetails,
  getSideBarBranch,
} from "../../redux/SideBarTeams/action";
import lock from "../../images/lock.png";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { saveDeletBrachIdDetails } from "../../redux/DeleteBranchName/action";
import { saveDeletTeamsIdDetails } from "../../redux/DeleteTeamsDetails/action";
import { GetBranchCountDetails } from "../../redux/BranchCount/action";
import useSession from "../CustomLogout/useSession";

const SideMenuPartnerDashboard = (props) => {
  const handleSessionExpired = useSession();
  const roleType = useSelector(
    (state) => state?.auth?.checkLogin?.dto?.loggedInRoleType
  );
  const stageStatus = useSelector(
    (state) =>
      state?.dashboardReducer?.dashboardDetails?.data?.dto?.partnerFirmStatus
  );
  const [engagementDetailsList, setEngagementDetailsList] = useState(true);
  const [firmDetailsList, setirmDetailsList] = useState(false);
  const [branchDetailsList, setBranchdetailsList] = useState(false);
  const [teamsDetailsList, setTeamsdetailsList] = useState(false);
  const [teamCount, setTeamCount] = useState(0);

  const [branchCount, setBranchCount] = useState(0);

  const [form] = Form.useForm();

  const [Branch, setBranch] = useState(
    useSelector((state) => state.teamSideBar)
  );

  const [teamDetails, setTeamDetails] = useState(
    useSelector((state) => state.teamSideBar)
  );

  let navigate = useNavigate();

  let NavigateBranch = (e, BranchId, id) => {
    navigate(`/PartnerDashBoard/branchdetails`, {
      state: {
        id,
        BranchId,
      },
    });
  };

  let NavigateBranchTitle = (e, BranchId, id) => {
    Branch.length > 0
      ? navigate(`/PartnerDashBoard/branchdetails`, {
          state: {
            id,
            BranchId,
          },
        })
      : navigate(`/PartnerDashBoard/branchdetailsfornew`);
  };

  let Navigate = (e, teamId, id) => {
    navigate(`/PartnerDashBoard/teamdetails`, {
      state: { teamId, id },
    });
  };

  let NavigateTeamTitle = (e, teamId, id) => {
    teamDetails.length > 0
      ? navigate(`/PartnerDashBoard/teamdetails`, {
          state: { teamId, id },
        })
      : navigate(`/PartnerDashBoard/teamdetailsfornew`);
  };

  useEffect(() => {
    setBranch(props?.data.branchDetails);
    setTeamDetails(
      props?.data?.sidebarTeamsDetails?.PARTNER_TEAM_PERSON_MASTER
    );
    props?.data?.sidebarTeamsDetails?.count !== undefined
      ? setTeamCount(props?.data?.sidebarTeamsDetails?.count)
      : setTeamCount(0);
    props.BranchCount.count !== undefined
      ? setBranchCount(props.BranchCount.count)
      : setBranchCount(0);
  }, [props?.data]);

  const hideDetails = () => {
    setEngagementDetailsList(true);
    setirmDetailsList(false);
    setBranchdetailsList(false);
    setTeamsdetailsList(false);
  };
  const hideFirmDetails = () => {
    setEngagementDetailsList(false);
    setirmDetailsList(true);
    setBranchdetailsList(false);
    setTeamsdetailsList(false);
  };
  const hideBranchDetails = () => {
    setEngagementDetailsList(false);
    setirmDetailsList(false);
    setBranchdetailsList(true);
    setTeamsdetailsList(false);
  };
  const hideTeamsDetails = () => {
    setEngagementDetailsList(false);
    setirmDetailsList(false);
    setBranchdetailsList(false);
    setTeamsdetailsList(true);
  };

  const Id = sessionStorage.getItem("cetFirmId");
  const partnerSidebarDtoList =
    props?.partnerSidebarDtoList?.length > 0
      ? props?.partnerSidebarDtoList
      : [];

  const EngagementDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "EngagementDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const FirmDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "FirmDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const BranchDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "BranchDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const TeamDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "TeamDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const DocumentStatus =
    partnerSidebarDtoList?.find((item) => item.page === "Documents")?.status ===
    "COMPLETE"
      ? true
      : false;

  const loggedInRoleType = props.userData?.loggedInRoleType ?? "";

  const checkRM = loggedInRoleType === "RM";

  const handleDeleteChanges = (id, firmId) => {
    const partnerFirmId = firmId;
    const partnerBranchId = id;
    props
      .saveDeletBrachIdDetails({
        access_token: props.access_token,
        partnerFirmId: partnerFirmId,
        partnerBranchId: partnerBranchId,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Branch Deleted Successfully");
          props.GetBranchCountDetails({
            access_token: props.access_token,
            partnerFirmId: partnerFirmId,
          });

          props
            .getBranchData({
              accessToken: props.access_token,
              partnerFirmId: partnerFirmId,
            })
            .then((res) => {
              navigate(`/PartnerDashBoard/branchdetailsfornew`);

              if (res?.data?.error || res.message) {
                const errorCode = res?.data?.error?.errorCode || res.errorCode;
                const errorMessage = res?.data?.error?.message || res.message;

                if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                  handleSessionExpired();
                } else {
                  notification.error({
                    description: errorMessage,
                    duration: 5,
                    placement: "top",
                  });
                }
              }
            });
          hideBranchDetails();
          setIsModalVisible(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const handleDeleteChangesTeams = (teamId, id) => {
    const partnerFirmId = id;
    const partnerTeamId = teamId;
    props
      .saveDeletTeamsIdDetails({
        access_token: props.access_token,
        partnerFirmId: partnerFirmId,
        partnerTeamId: partnerTeamId,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Team Deleted Successfully");
          props.getTeamsData({
            accessToken: props.access_token,
            partnerFirmID: partnerFirmId,
          });
          hideTeamsDetails();
          setModalTeamsDetele(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTeamsDetele, setModalTeamsDetele] = useState(false);

  const showTeamsModel = () => {
    setModalTeamsDetele(true);
  };
  const ModelTeamsCancel = () => {
    setModalTeamsDetele(false);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <div className="log-avs">
        <img src={Logo} alt="" />
      </div>

      <div className="list-contnt scrolllist">
        <ul className="list">
          <li className="">
            <Link
              onClick={hideDetails}
              className="ListItem"
              to="/PartnerDashBoard/EngagementDetails"
            >
              <img src={PartnerLogo} alt="" className="sidebarIcon" />
              <span className="list-Text">Engagement Details</span>
            </Link>
          </li>

          {engagementDetailsList ? (
            <ul className="inner-list">
              <li className="text-inner-list">
                <Nav.Link
                  activeclassname="active"
                  href="/PartnerDashBoard/EngagementDetails#EngagmentType"
                  className="navigation__link"
                >
                  Engagement Type
                </Nav.Link>
              </li>

              <li className="text-inner-list">
                <Nav.Link
                  activeclassname="active"
                  href="/PartnerDashBoard/EngagementDetails#EngagmentRole"
                  className="navigation__link"
                >
                  Role With Avanse
                </Nav.Link>
              </li>
              <li className="text-inner-list">
                <Nav.Link
                  activeclassname="active"
                  href="/PartnerDashBoard/EngagementDetails#EngagmentProduct"
                  className="navigation__link"
                >
                  Products Interested
                </Nav.Link>
              </li>
            </ul>
          ) : null}

          {EngagementDetailStatus ? (
            <>
              <li>
                <Link
                  onClick={hideFirmDetails}
                  className="ListItem"
                  to="/PartnerDashBoard/FirmDetails"
                >
                  <img src={LeadLogo} alt="" className="sidebarIcon" />
                  <span className="list-Text">Firm Details</span>
                </Link>
              </li>
              {firmDetailsList ? (
                <ul className="inner-list">
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/FirmDetails#Constitution"
                    className="navigation__link"
                  >
                    <li className="text-inner-list">Firm Constitution</li>
                  </Nav.Link>
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/FirmDetails#PanVerification"
                    className="navigation__link"
                  >
                    <li className="text-inner-list">PAN Verification</li>
                  </Nav.Link>
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/FirmDetails#FirmDetails"
                    className="navigation__link"
                  >
                    <li className="text-inner-list">Firm Details</li>
                  </Nav.Link>
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/FirmDetails#HeadOffice"
                    className="navigation__link"
                  >
                    <li className="text-inner-list">Head Office Details</li>
                  </Nav.Link>
                  <Nav.Link
                    activeclassname="active"
                    href="/PartnerDashBoard/FirmDetails#BankDetails"
                    className="navigation__link"
                  >
                    <li className="text-inner-list">Bank Details</li>
                  </Nav.Link>
                  {roleType === "RM" ? (
                    <Nav.Link
                      activeclassname="active"
                      href="/PartnerDashBoard/FirmDetails#PayoutDetails"
                      className="navigation__link"
                    >
                      <li className="text-inner-list">Payout Details</li>
                    </Nav.Link>
                  ) : null}
                </ul>
              ) : null}
            </>
          ) : (
            <li>
              <div className="btn-seclast">
                <div className="lock-sidebar">
                  <img src={LeadLogo} alt="" className="sidebarIcon" />
                  <span className="list-Text">Firm Details</span>
                </div>
                <div className="lock-sidebar-img">
                  <img src={lock} alt="" />
                </div>
              </div>
            </li>
          )}

          {EngagementDetailStatus && FirmDetailStatus ? (
            <>
              <li
                onClick={(e) => {
                  NavigateBranchTitle(
                    e,
                    Branch[Branch?.length - 1]?.partnerBranchId,
                    Branch[Branch?.length - 1]?.partnerFirmId
                  );
                  hideBranchDetails();
                }}
              >
                <Link
                  className="ListItem"
                  to={
                    Branch?.length >= 25
                      ? `/PartnerDashBoard/branchdetails`
                      : "/PartnerDashBoard/branchdetailsfornew"
                  }
                >
                  <img src={BranchDetails} alt="" className="sidebarIcon" />
                  <div className="cbfcc">
                    <span className="list-Text">Branch Details</span>
                    <div className="fsfsfaf">{branchCount}</div>
                  </div>
                </Link>
              </li>
              {branchDetailsList && Branch?.length > 0 ? (
                <>
                  <ul>
                    <li className="text-inner-list-btn">
                      {Branch?.length < 25 ? (
                        <Link
                          to={"/PartnerDashBoard/branchdetailsfornew"}
                          className="addNewTeams"
                        >
                          <span className="list-Text">ADD NEW BRANCH</span>
                        </Link>
                      ) : (
                        ""
                      )}
                    </li>
                  </ul>
                  <ul className="inner-list  inner-Scroll-list">
                    {Branch.map((el) => {
                      return (
                        <li className="text-inner-list">
                          <div className="side-menu-slider">
                            <div className="img-del">
                              {/* <Tooltip title="prompt text"> */}{" "}
                              <img
                                src={deleteIcon}
                                alt=""
                                onClick={showModal}
                              />
                            </div>
                            <Modal
                              open={isModalVisible}
                              closable={false}
                              className="modal-container"
                              centered
                              footer={null}
                            >
                              <Row className="mt-4">
                                <Col lg={12} xs={12} md={12} sm={12}>
                                  <p>Are you sure you want to delete Branch?</p>
                                </Col>
                              </Row>

                              <Row className="mt-4">
                                <Col
                                  md={12}
                                  className="d-flex justify-content-end mt-4"
                                >
                                  <Button
                                    className="mr-3"
                                    htmlType="button"
                                    type="default"
                                    onClick={handleCancel}
                                  >
                                    No
                                  </Button>
                                  <Button
                                    onClick={() => {
                                      handleDeleteChanges(
                                        el?.partnerBranchId,
                                        el?.partnerFirmId
                                      );
                                    }}
                                    className=""
                                    type="primary"
                                  >
                                    Yes
                                  </Button>
                                </Col>
                              </Row>
                            </Modal>
                            <div
                              className="text-sec"
                              onClick={(e) => {
                                NavigateBranch(
                                  e,
                                  el?.partnerBranchId,
                                  el?.partnerFirmId
                                );
                              }}
                            >
                              {el?.partnerBranchLocationAddress?.cityName +
                                " " +
                                el?.partnerBranchLocationAddress?.pincode}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </>
              ) : null}
            </>
          ) : (
            <li>
              <div className="btn-seclast">
                <div className="lock-sidebar">
                  <img src={BranchDetails} alt="" className="sidebarIcon" />

                  <span className="list-Text">Branch Details</span>
                </div>
                <div className="lock-sidebar-img">
                  <img src={lock} alt="" />
                </div>
              </div>
            </li>
          )}

          {EngagementDetailStatus && FirmDetailStatus && BranchDetailStatus ? (
            <>
              <li
                onClick={(e) => {
                  hideTeamsDetails();
                  NavigateTeamTitle(
                    e,
                    teamDetails[teamDetails?.length - 1]?.partnerPersonId,
                    teamDetails[teamDetails?.length - 1]?.partnerFirmId
                  );
                }}
                className="list-Text"
              >
                <Link
                  className="ListItem  dguad"
                  to="/PartnerDashBoard/teamdetailsfornew"
                >
                  <img src={ApplicationLogo} alt="" className="sidebarIcon" />
                  <div className="cbfcc">
                    <span className="list-Text">Team Details</span>
                    <div className="fsfsfa">{teamCount}</div>
                  </div>
                </Link>
              </li>
              {teamsDetailsList ? (
                <>
                  <ul>
                    {teamDetails.length < 25 ? (
                      <li className="text-inner-list-btn">
                        <Link
                          className="addNewTeams"
                          to="/PartnerDashBoard/teamdetailsfornew"
                        >
                          <span className="list-Text">ADD NEW TEAM</span>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                  <ul className="inner-list inner-Scroll-list">
                    {teamDetails?.map((el) => {
                      return (
                        <li className="text-inner-list">
                          <div className="side-menu-slider">
                            <div className="img-del">
                              {/* <Tooltip title="prompt text"> */}{" "}
                              <img
                                src={deleteIcon}
                                alt=""
                                onClick={showTeamsModel}
                              />
                              <Modal
                                open={modalTeamsDetele}
                                closable={false}
                                className="modal-container"
                                centered
                                footer={null}
                              >
                                <Row className="mt-4">
                                  <Col lg={12} xs={12} md={12} sm={12}>
                                    <p>
                                      Are you sure you want to delete Team
                                      Person?
                                    </p>
                                  </Col>
                                </Row>

                                <Row className="mt-4">
                                  <Col
                                    md={12}
                                    className="d-flex justify-content-end mt-4"
                                  >
                                    <Button
                                      className="mr-3"
                                      htmlType="button"
                                      type="default"
                                      onClick={ModelTeamsCancel}
                                    >
                                      No
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        handleDeleteChangesTeams(
                                          el?.partnerPersonId,
                                          el?.partnerFirmId
                                        );
                                      }}
                                      className=""
                                      type="primary"
                                    >
                                      Yes
                                    </Button>
                                  </Col>
                                </Row>
                              </Modal>
                              {/* </Tooltip> */}
                            </div>
                            <div
                              className="text-sec"
                              onClick={(e) => {
                                Navigate(
                                  e,
                                  el?.partnerPersonId,
                                  el?.partnerFirmId
                                );
                              }}
                            >
                              {el?.personFullName}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </>
              ) : null}
            </>
          ) : (
            <li>
              <div className="btn-seclast">
                <div className="lock-sidebar">
                  <img src={ApplicationLogo} alt="" className="sidebarIcon" />
                  <span className="list-Text">Team Details</span>
                </div>
                <div className="lock-sidebar-img">
                  <img src={lock} alt="" />
                </div>
              </div>
            </li>
          )}

          {/* <li>
            {EngagementDetailStatus &&
            FirmDetailStatus &&
            BranchDetailStatus &&
            TeamDetailStatus ? (
              <>
                {!checkRM ? (
                  <Link className="ListItem" to="/partnerdashboard/user">
                    <img src={Human} alt="" className="sidebarIcon" />
                    <span className="list-Text">User Details</span>
                  </Link>
                ) : (
                  ""
                )}
              </>
            ) : (
              <>
                {!checkRM ? (
                  <div className="btn-seclast">
                    <div className="lock-sidebar">
                      <img src={Human} alt="" className="sidebarIcon" />
                      <span className="list-Text">User Details</span>
                    </div>
                    <div className="lock-sidebar-img">
                      <img src={lock} alt="" />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </li> */}
          <li>
            {EngagementDetailStatus &&
            FirmDetailStatus &&
            BranchDetailStatus &&
            TeamDetailStatus ? (
              <>
                <Link className="ListItem" to="/partnerdashboard/document">
                  <img src={Documents} alt="" className="sidebarIcon" />
                  <span className="list-Text">Documents</span>
                </Link>
              </>
            ) : (
              <div className="btn-seclast">
                <div className="lock-sidebar">
                  <img src={Documents} alt="" className="sidebarIcon" />
                  <span className="list-Text">Documents</span>
                </div>
                <div className="lock-sidebar-img">
                  <img src={lock} alt="" />
                </div>
              </div>
            )}
          </li>
        </ul>
      </div>
      <div className="list-contnt">
        {loggedInRoleType === "RM" && (
          <ul className="list">
            <li className="">
              <Link
                className="ListItem"
                to={{
                  pathname: "/RMDashboard/edit-partner",
                }}
                state={{ partnerFirmId: +Id }}
              >
                <img src={BackArrow} alt="" className="sidebarIcon" />
                <span
                  className="list-Text"
                  style={{
                    color: "#fec211",
                  }}
                >
                  Back To Partner Details
                </span>
              </Link>
            </li>
          </ul>
        )}
        {loggedInRoleType === "PARTNER" && (
          <ul className="list">
            <li className="back-btn-partner">
              <Link
                className="ListItem"
                to={`/leadManagementDashboard/Dashboard`}
              >
                <img src={BackArrow} alt="" className="sidebarIcon" />
                <span
                  className="list-Text"
                  style={{
                    color: "#fec211",
                  }}
                >
                  Back To Main Menu
                </span>
              </Link>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveDeletBrachIdDetails: (data) => dispatch(saveDeletBrachIdDetails(data)),
    saveDeletTeamsIdDetails: (data) => dispatch(saveDeletTeamsIdDetails(data)),
    getTeamsData: (data) => dispatch(getTeamSideBarDetails(data)),
    getBranchData: (data) => dispatch(getSideBarBranch(data)),
    GetBranchCountDetails: (data) => dispatch(GetBranchCountDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    access_token: state.auth?.idToken,
    data: state.teamSideBar,
    partnerSidebarDtoList: state.partnerSidebar?.partnerSidebarDtoList,
    userData: state.auth?.userData,
    BranchCount: state.BranchCount.branchcount,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SideMenuPartnerDashboard);
